/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import { useTeamsStats } from '../../../hooks/teamStats';
import { useTeamFilterOptions } from '../FilterOptions/TeamFilterOptions';
import _ from 'lodash';
import { usePlayersStats } from '../../../hooks/playerStats';
import { usePlayerFilterOptions } from '../FilterOptions/PlayerFilterOptions';
import PlayersTableRow from './PlayersTableRow';
import LoadMorePlayers from '../LoadMorePlayers';

function PlayersTable({
  playersStats,
  playersStatsLoading,
  playerLimit,
  setPlayerLimit,
  season,
  orderBy,
  team,
  position,
  nationality,
  }) {
  let sortedPlayers = _.orderBy(playersStats, orderBy, 'desc');
  sortedPlayers = _.filter(sortedPlayers, function(item) {
    return item[orderBy] > 0
  });
  sortedPlayers?.map((player, i) => {
    if (player.displayName === 'undefined undefined') {
      sortedPlayers.splice(i, 1);
    }
  });

  if (team !== 'Alla lag') {
    sortedPlayers = _.filter(sortedPlayers, function (item) {
      return item.teamAbbrv === team;
    });
  }
  if (position !== 'Alla positioner') {
    sortedPlayers = _.filter(sortedPlayers, function (item) {
      return item.position === position;
    });
  }
  if (nationality !== 'Alla nationaliteter') {
    sortedPlayers = _.filter(sortedPlayers, function (item) {
      return item.nationality === nationality;
    });
  }
  const loadedRows =
    playerLimit === 0 ? sortedPlayers : sortedPlayers.slice(0, playerLimit);

  if (loadedRows.length && !playersStatsLoading) {
    return (
      <>
        {loadedRows?.map((player, i) => (
          <PlayersTableRow player={player} i={i + 1} orderBy={orderBy} />
        ))}
        <LoadMorePlayers playerLimitSetter={setPlayerLimit} />
      </>
    );
  } else if (playersStatsLoading) {
    return (
      <div className="stats-table__row">
        <div className="col-12 text-center stats-font-larger">Loading...</div>
      </div>
    );
  } else {
    return (
      <div className="stats-table__row">
        <div className="col-12 text-center stats-font-larger">
          Ingen data tillgänglig.
        </div>
      </div>
    );
  }
}
export default PlayersTable;
